import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  CheckCircle2, AlertTriangle, Cable, Printer, Unplug, Loader2, Play,
} from "lucide-react";

const SERIAL_ADVANTAGES = [
  ["Mais compativel", "Funciona com 99% das termicas"],
  ["Sem popup", "Conecta 1x e lembra depois"],
  ["ESC/POS direto", "Comandos nativos da impressora"],
  ["Sem software", "Nao precisa de Java/QZ Tray"],
];

export function SerialPrinterSection({
  serialSupported,
  serialPrinter,
  serialConnecting,
  serialTestPrinting,
  handleConnectSerial,
  handleDisconnectSerial,
  handleTestSerial,
}) {
  if (!serialSupported) {
    return (
      <Card className="border-l-4 border-l-red-500">
        <CardContent className="py-6">
          <div className="flex items-start gap-3">
            <AlertTriangle className="w-6 h-6 text-red-500 flex-shrink-0" />
            <div>
              <p className="font-bold text-red-700">Navegador nao suportado</p>
              <p className="text-sm text-red-600 mt-1">
                Web Serial so funciona no <strong>Google Chrome</strong> ou <strong>Microsoft Edge</strong>.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      <Card className="border-l-4 border-l-emerald-500" data-testid="serial-advantages">
        <CardContent className="py-4">
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 text-center">
            {SERIAL_ADVANTAGES.map(([title, desc], i) => (
              <div key={i} className="space-y-1">
                <CheckCircle2 className="w-5 h-5 text-emerald-500 mx-auto" />
                <p className="text-xs font-bold text-gray-700">{title}</p>
                <p className="text-[10px] text-gray-500">{desc}</p>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      <Card
        className={`border-l-4 ${serialPrinter ? "border-l-emerald-500" : "border-l-blue-500"}`}
        data-testid="serial-connection"
      >
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-base">
            <Cable className="w-5 h-5" />
            {serialPrinter ? "Impressora Conectada" : "Conectar via Porta Serial"}
            {serialPrinter && (
              <Badge className="bg-emerald-100 text-emerald-700 ml-auto text-[10px]">Conectada</Badge>
            )}
            {!serialPrinter && (
              <Badge className="bg-emerald-100 text-emerald-700 ml-auto text-[10px]">Recomendado</Badge>
            )}
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4 pt-0">
          {serialPrinter ? (
            <>
              <div className="flex items-center gap-3 p-3 bg-emerald-50 rounded-lg">
                <Printer className="w-6 h-6 text-emerald-600" />
                <div>
                  <p className="font-bold text-emerald-800">{serialPrinter.name}</p>
                  <p className="text-[10px] text-emerald-600">Conectada via porta serial</p>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={handleDisconnectSerial}
                  className="ml-auto gap-1"
                  data-testid="disconnect-serial-btn"
                >
                  <Unplug className="w-3 h-3" /> Desconectar
                </Button>
              </div>
              <Button
                onClick={handleTestSerial}
                disabled={serialTestPrinting}
                className="bg-emerald-600 hover:bg-emerald-700 gap-2 h-12 font-bold text-base w-full"
                data-testid="test-serial-print-btn"
              >
                {serialTestPrinting ? (
                  <Loader2 className="w-5 h-5 animate-spin" />
                ) : (
                  <Play className="w-5 h-5" />
                )}
                IMPRIMIR PAGINA DE TESTE
              </Button>
            </>
          ) : (
            <>
              <div className="space-y-2">
                <p className="text-sm text-gray-600">
                  Conecte a impressora termica via <strong>cabo USB</strong> e clique abaixo.
                  O navegador mostra as portas seriais disponiveis (COM3, COM4, etc).
                </p>
                <div className="bg-emerald-50 border border-emerald-200 p-3 rounded-lg text-xs text-emerald-700 space-y-1">
                  <p className="font-bold">Compativel com:</p>
                  <ul className="list-disc list-inside space-y-0.5">
                    <li>Epson TM-T20, TM-T88, TM-M30</li>
                    <li>Star TSP100, TSP143, mPOP</li>
                    <li>Bixolon SRP-350, SRP-330</li>
                    <li>Qualquer impressora ESC/POS com porta USB/Serial</li>
                  </ul>
                </div>
              </div>
              <Button
                onClick={handleConnectSerial}
                disabled={serialConnecting}
                className="bg-emerald-600 hover:bg-emerald-700 gap-2 h-12 font-bold text-base w-full"
                data-testid="connect-serial-btn"
              >
                {serialConnecting ? (
                  <Loader2 className="w-5 h-5 animate-spin" />
                ) : (
                  <Cable className="w-5 h-5" />
                )}
                CONECTAR IMPRESSORA
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
